// const envSettings = (process.env.NODE_ENV === 'development' ? process.env : window) as any
const envSettings = window as any

const origin = window.location.origin;
const isInsecureOrigin = origin.startsWith('http://');
// derive hostname and subdomain
const hostname = window.location.hostname || '';
// helper: check if hostname is an IP address
const isIpAddress = /^\d+\.\d+\.\d+\.\d+$/.test(hostname);
// compute subdomain: if hostname is localhost or IP or has only two labels, return empty string
let subdomain = '';
let azureContainer = '';
if (hostname && hostname !== 'localhost' && !isIpAddress) {
  const parts = hostname.split('.');
  if (parts.length > 2) {
    subdomain = parts[0];
    azureContainer = subdomain;
    if(subdomain ==='dev')
      azureContainer = 'development';

    if(hostname === 'demo.cliniterplus.com')
      azureContainer = 'demoplus'
  }
}

export class Config {
  static REACT_APP_LINE_NOTI_CLIENT_ID = envSettings.REACT_APP_LINE_NOTI_CLIENT_ID
  static REACT_APP_LINE_NOTI_CLIENT_SECRET = envSettings.REACT_APP_LINE_NOTI_CLIENT_SECRET
  static REACT_APP_LINE_NOTI_CALLBACK_URL = envSettings.REACT_APP_LINE_NOTI_CALLBACK_URL
  static REACT_APP_APP_NAME = envSettings.REACT_APP_APP_NAME
  static REACT_APP_VERSION = process.env.REACT_APP_VERSION ?? envSettings.REACT_APP_VERSION ?? '0.1.0'
  static REACT_APP_API_KEY = envSettings.REACT_APP_API_KEY
  static REACT_APP_BASE_URL = isInsecureOrigin
    ? envSettings.REACT_APP_BASE_URL
    :   `${origin}/api`
  static AZURE_CONTAINER = isInsecureOrigin  ? envSettings.AZURE_CONTAINER : azureContainer
  static REACT_APP_IMAGE_URL = isInsecureOrigin ? envSettings.REACT_APP_IMAGE_URL : `https://cliniterdental.blob.core.windows.net/${azureContainer}`
  static REACT_APP_DOMAIN = envSettings.REACT_APP_DOMAIN
  static REACT_APP_URL = envSettings.REACT_APP_URL
  static REACT_APP_CLINIC_THEME = envSettings.REACT_APP_CLINIC_THEME
  static REACT_APP_LOGO = envSettings.REACT_APP_LOGO
  static REACT_APP_BACKGROUND = envSettings.REACT_APP_BACKGROUND
  static REACT_APP_BASE_URL_IO = isInsecureOrigin
    ? envSettings.REACT_APP_BASE_URL_IO
    :  origin
  static REACT_APP_SUBDOMAIN = subdomain
  static IS_TDH = envSettings.IS_TDH || '0'
  static IS_DIO = envSettings.IS_DIO || '0'
  static IS_VDH = envSettings.IS_VDH || '0'
  static URL_ALERT_UPDATE = envSettings.URL_ALERT_UPDATE
  static LIST_DOCTOR_SCHEDULE = envSettings.LIST_DOCTOR_SCHEDULE
}
